import { PhoneNumberUtil } from "google-libphonenumber";

import { validateEmail } from "../../utils/helpers";

import countries from "../../utils/countries.json";

const countryCodes = countries.map(country => country[0]);

const phoneUtil = PhoneNumberUtil.getInstance();
const cellTypeValues = ["delivery", "pickup"];

const cellValidator = (name, value, row) => {
  switch (name) {
    case "type":
      return value !== null && cellTypeValues.includes(value);
    case "street":
      return (row.lat && row.long) || !!value;
    case "postal_code":
      return (row.lat && row.long) || !!value;
    case "country_code": {
      const cleanCountryCode = value?.trim();
      if (row.lat && row.long) return true;
      return (
        value !== null &&
        typeof value === "string" &&
        cleanCountryCode.length === 2 &&
        countryCodes.includes(cleanCountryCode.toUpperCase())
      );
    }
    case "duration":
    case "unit_count":
    case "unit_weight":
    case "unit_volume":
      return value ? !Number.isNaN(Number(value)) : true;
    case "email":
      return value ? validateEmail(value) : true;
    case "phone":
      if (value) {
        try {
          phoneUtil.isValidNumber(phoneUtil.parse(value));
          return true;
        } catch (error) {
          return false;
        }
      }
      return true;
    default:
      return true;
  }
};

export { cellValidator };
